import { LineLoading } from "@/components/loading";

export function LoadingComponent() {
	return (
		<div className="w-screen h-screen flex flex-col items-center justify-center">
			<LineLoading />
		</div>
	);
}
